import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DotDotDotIcon, MutedSpeakerIcon, ShareIcon, UnmutedSpeakerIcon, } from '@streamr/tv-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import styled, { css } from 'styled-components';
import { useShare } from '../../hooks/useShare';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { ViewerService } from '../../services/viewer/ViewerService';
import { formBroadcastUrl } from '../../utils/url';
import { Anchor } from '../Anchor';
import { Button } from '../Button';
import { openViewerOptions } from '../popups/ViewerOptionsPopup';
export function ViewerFooter(props) {
    const { audioMuted = false } = props;
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const navigate = useNavigate();
    const { canShare, openSystemShareDialog } = useShare();
    const optionsButtonAnchorRef = useRef(null);
    const broadcastUrl = formBroadcastUrl(activeBroadcast);
    return (_jsxs(ViewerFooterRoot, { "$showShareButton": canShare, children: [_jsx(Wedge, {}), _jsx(Button, { type: "button", shape: "pill", padding: "none", kind: audioMuted ? undefined : 'secondary', variant: audioMuted ? undefined : 'dark', icon: audioMuted ? _jsx(MutedSpeakerIcon, {}) : _jsx(UnmutedSpeakerIcon, {}), onClick: () => {
                    ViewerService.getNotificationInterface().notifyMuteToggle();
                } }), canShare && (_jsx(Button, { type: "button", kind: "secondary", shape: "pill", padding: "none", variant: "dark", icon: _jsx(ShareIcon, {}), onClick: () => {
                    openSystemShareDialog(broadcastUrl);
                } })), _jsx(Anchor, { ref: optionsButtonAnchorRef, children: _jsx(Button, { type: "button", kind: "secondary", shape: "pill", padding: "none", variant: "dark", icon: _jsx(DotDotDotIcon, {}), onClick: () => {
                        openViewerOptions({
                            anchorRef: optionsButtonAnchorRef,
                            activeBroadcast,
                            variant: 'desktop',
                        });
                    } }) }), _jsx(Button, { type: "button", kind: "destructive", shape: "pill", onClick: () => {
                    navigate('/');
                }, children: "Leave" }), _jsx(Wedge, {})] }));
}
const Wedge = styled.div `
    display: var(--Wedge_Display, block);
`;
const ViewerFooterRoot = styled.div `
    --Wedge_Display: none;

    align-items: center;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding: 1.5rem;

    @media (min-width: 48rem) {
        --Wedge_Display: initial;

        display: grid;
        grid-template-columns: 1fr auto auto auto auto 1fr;
        gap: 1rem;
        justify-content: initial;

        ${({ $showShareButton }) => !$showShareButton &&
    css `
                grid-template-columns: 1fr auto auto auto 1fr;
            `}
    }
`;
